export default {
  getReason: (state) => state.reason,
  getReasonByTask: (state) => (taskId) => state.reasons
    .filter((task) => task.taskId === taskId)
    .sort((a, b) => a.order - b.order),
};
